import React, { createContext, useContext, useMemo } from 'react';
import { useComposeFormInteractions } from '@/components/Drawers/AddUnlayerEmailDrawer/hooks/useComposeFormInteractions';

const UnlayerComposeInteractionsContext = createContext(null);

/**
 * Exposes compose interaction handlers that coordinate Formik, drafts, templates,
 * and local UI state across the email drawer.
 */
export const UnlayerComposeInteractionsProvider = ({ children }) => {
	const interactions = useComposeFormInteractions();

	const value = useMemo(
		() => interactions,
		[
			interactions.handleClientChange,
			interactions.handleClose,
			interactions.handleDealChange,
			interactions.handleDraftSelect,
			interactions.handleEditorChange,
			interactions.handleLoadDesignJson,
			interactions.handleLoadDesignJsonValueChange,
			interactions.handleReplaceDraft,
			interactions.handleTemplateSelect,
			interactions.handleValidateAndOpenSendDialog,
		],
	);

	return (
		<UnlayerComposeInteractionsContext.Provider value={value}>
			{children}
		</UnlayerComposeInteractionsContext.Provider>
	);
};

export const useUnlayerComposeInteractionsContext = () => {
	const context = useContext(UnlayerComposeInteractionsContext);
	if (!context) {
		throw new Error(
			'useUnlayerComposeInteractionsContext must be used within an UnlayerComposeInteractionsProvider',
		);
	}
	return context;
};
